export default "__VITE_PUBLIC_ASSET__541a8643__"